/**
 * Auto-generated by server/scripts/generate_normalized_ingredients_constants.py
 * Do not edit by hand.
 *
 * Regenerate:
 *   cd server && python scripts/generate_normalized_ingredients_constants.py
 */

export const NORMALIZED_INGREDIENT_OPTIONS = [
  { name: "Acadian Redfish" },
  { name: "Added Color" },
  { name: "Agar" },
  { name: "Agar Agar" },
  { name: "Agar-Agar" },
  { name: "Alfalfa Meal" },
  { name: "Alfalfa Nutrient Concentrate" },
  { name: "Aloe Vera Extract" },
  { name: "Aloe Vera Gel Concentrate" },
  { name: "Anchovy" },
  { name: "Animal Fat" },
  { name: "Animal Liver" },
  { name: "Animal Liver Flavor" },
  { name: "Animal Plasma" },
  { name: "Apple" },
  { name: "Apple Cider Vinegar" },
  { name: "Apples" },
  { name: "Arctic Char" },
  { name: "Artichokes" },
  { name: "Artificial Color" },
  { name: "Barley" },
  { name: "Barley Grass" },
  { name: "Beef" },
  { name: "Beef Broth" },
  { name: "Beef Fat" },
  { name: "Beef Heart" },
  { name: "Beef Kidney" },
  { name: "Beef Liver" },
  { name: "Beef Lung" },
  { name: "Beef Spleen" },
  { name: "Beef Tripe" },
  { name: "Beets" },
  { name: "Beta Carotene" },
  { name: "Beta-Carotene" },
  { name: "Betaine" },
  { name: "Betaine Anhydrous" },
  { name: "Bha" },
  { name: "Bht" },
  { name: "Blueberry" },
  { name: "Blueberry Powder" },
  { name: "Boar" },
  { name: "Brewers Dried Yeast" },
  { name: "Brewers Rice" },
  { name: "Brewers Rice Flour" },
  { name: "Brewers Yeast" },
  { name: "Broccoli" },
  { name: "Brown Rice" },
  { name: "Cabbage" },
  { name: "Calcium Carbonate" },
  { name: "Calcium Chloride" },
  { name: "Calcium Gluconate" },
  { name: "Calcium Iodate" },
  { name: "Calcium Lactate" },
  { name: "Calcium Propionate" },
  { name: "Calcium Sulfate" },
  { name: "Calcium Sulfate Dihydrate" },
  { name: "Calcium Sulphate" },
  { name: "Cane Molasses" },
  { name: "Cane Sugar" },
  { name: "Canola Meal" },
  { name: "Canola Oil" },
  { name: "Caramel Color" },
  { name: "Carob Bean Gum" },
  { name: "Carotene" },
  { name: "Carrageenan" },
  { name: "Carrot" },
  { name: "Casein" },
  { name: "Cassava Root Flour" },
  { name: "Cassia Gum" },
  { name: "Catfish" },
  { name: "Celery" },
  { name: "Celery Powder" },
  { name: "Cellulose" },
  { name: "Chamomile" },
  { name: "Cheese" },
  { name: "Cheese Powder" },
  { name: "Chicken" },
  { name: "Chicken Broth" },
  { name: "Chicken By-Product" },
  { name: "Chicken Cartilage" },
  { name: "Chicken Fat" },
  { name: "Chicken Flavor" },
  { name: "Chicken Giblets" },
  { name: "Chicken Gizzard" },
  { name: "Chicken Heart" },
  { name: "Chicken Liver" },
  { name: "Chicken Liver Flavor" },
  { name: "Chicken Meal" },
  { name: "Chicken Skin" },
  { name: "Chickpeas" },
  { name: "Chicory Root" },
  { name: "Choline Chloride" },
  { name: "Chondroitin Sulfate" },
  { name: "Cinnamon" },
  { name: "Citric Acid" },
  { name: "Clinoptilolite Of Sedimentary Origin" },
  { name: "Coconut" },
  { name: "Coconut Oil" },
  { name: "Cod" },
  { name: "Cod Liver" },
  { name: "Collard Greens" },
  { name: "Copper Amino Acid Chelate" },
  { name: "Copper Amino Acid Complex" },
  { name: "Copper Chelate Of Amino Acids Hydrate" },
  { name: "Copper Methionine Hydroxy Analogue Chelate" },
  { name: "Copper Proteinate" },
  { name: "Copper Sulfate" },
  { name: "Copper Sulphate Pentahydrate" },
  { name: "Corn" },
  { name: "Corn Flour" },
  { name: "Corn Gluten Meal" },
  { name: "Corn Grits" },
  { name: "Corn Oil" },
  { name: "Corn Protein Meal" },
  { name: "Corn Starch" },
  { name: "Corn Starch-Modified" },
  { name: "Crab" },
  { name: "Crab Meal" },
  { name: "Crab Surimi" },
  { name: "Cracked Pearled Barley" },
  { name: "Cranberry" },
  { name: "Cysteine" },
  { name: "Cystine" },
  { name: "Dandelion" },
  { name: "Dandelion Greens" },
  { name: "Dandelion Leaf Powder" },
  { name: "Dandelion Powder" },
  { name: "Dextrose" },
  { name: "Dicalcium Phosphate" },
  { name: "Direct Alfalfa Pellets" },
  { name: "Disodium Phosphate" },
  { name: "DL-Methionine" },
  { name: "Dried Alfalfa Meal" },
  { name: "Dried Algae" },
  { name: "Dried Aspergillus Niger Fermentation Extract" },
  { name: "Dried Aspergillus Oryzae Fermentation Extract" },
  { name: "Dried Banana" },
  { name: "Dried Beet Pulp" },
  { name: "Dried Blueberry" },
  { name: "Dried Carrot" },
  { name: "Dried Celery" },
  { name: "Dried Citrus Pulp" },
  { name: "Dried Clover Extract" },
  { name: "Dried Coconut" },
  { name: "Dried Cultured Skim Milk" },
  { name: "Dried Cultured Whey" },
  { name: "Dried Dandelion Greens" },
  { name: "Dried Dandelion Root Extract" },
  { name: "Dried Green Lentils" },
  { name: "Dried Ground Pea" },
  { name: "Dried Ground Potato" },
  { name: "Dried Hydrolyzed Casein" },
  { name: "Dried Kale" },
  { name: "Dried Kiwi" },
  { name: "Dried Mango" },
  { name: "Dried Papaya" },
  { name: "Dried Parsley" },
  { name: "Dried Pineapple" },
  { name: "Dried Plain Beet Pulp" },
  { name: "Dried Pomegranate" },
  { name: "Dried Quinoa" },
  { name: "Dried Spinach" },
  { name: "Dried Sweet Orange" },
  { name: "Dried Sweet Potato" },
  { name: "Dried Tomato Pomace" },
  { name: "Dried Tomatoes" },
  { name: "Dried Trichoderma Longibrachiatum Fermentation Extract" },
  { name: "Dried Whey" },
  { name: "Dried Whey Protein Concentrate" },
  { name: "Dried Yeast" },
  { name: "Dried Yellow Pea" },
  { name: "Dried Yucca Schidigera Extract" },
  { name: "Duck" },
  { name: "Duck Broth" },
  { name: "Duck Liver" },
  { name: "Duck Meal" },
  { name: "Egg" },
  { name: "Egg Shell" },
  { name: "Fennel Powder" },
  { name: "Fenugreek Seed" },
  { name: "Ferrous Glycine" },
  { name: "Ferrous Sulfate" },
  { name: "Ferrous Sulphate Monohydrate" },
  { name: "Filtered Water" },
  { name: "Fish" },
  { name: "Fish Broth" },
  { name: "Fish Extract" },
  { name: "Fish Flavor" },
  { name: "Fish Meal" },
  { name: "Fish Oil" },
  { name: "Flavor" },
  { name: "Flaxseed" },
  { name: "Flaxseed Oil" },
  { name: "Flaxseeds" },
  { name: "Flounder" },
  { name: "Formulated Without Corn" },
  { name: "Fructo-Oligosaccharide" },
  { name: "Fructooligosaccharide" },
  { name: "Garbanzo Beans" },
  { name: "Gelatin" },
  { name: "Ginger" },
  { name: "Gla Safflower Oil" },
  { name: "Glucono-Delta-Lactone" },
  { name: "Glucosamine Hydrochloride" },
  { name: "Glucosamine Sulfate" },
  { name: "Glycerin" },
  { name: "Glyceryl Monostearate" },
  { name: "Glycine" },
  { name: "Goat Milk" },
  { name: "Goat S Milk" },
  { name: "Grain Brown Rice" },
  { name: "Grain Corn" },
  { name: "Grain Distillers Dried Yeast" },
  { name: "Grain Oatmeal" },
  { name: "Grain Oats" },
  { name: "Grain Wheat" },
  { name: "Green Beans" },
  { name: "Green Lentils" },
  { name: "Green Mussels" },
  { name: "Green Pea" },
  { name: "Green Tea Extract" },
  { name: "Green-Lipped Mussel Powder" },
  { name: "Ground Dried Pea" },
  { name: "Ground Flaxseed" },
  { name: "Ground Grain Corn" },
  { name: "Ground Grain Sorghum" },
  { name: "Ground Miscanthus Grass" },
  { name: "Ground Pecan Shells" },
  { name: "Ground Rice" },
  { name: "Ground Wheat Ground Wheat" },
  { name: "Ground Yellow Corn" },
  { name: "Guar Gum" },
  { name: "Hake" },
  { name: "Herring" },
  { name: "Herring Broth" },
  { name: "Herring Meal" },
  { name: "Herring Oil" },
  { name: "Hydrolyzed Chicken Flavor" },
  { name: "Hydrolyzed Chicken Liver" },
  { name: "Hydrolyzed Fish" },
  { name: "Hydrolyzed Herring" },
  { name: "Hydrolyzed Pork" },
  { name: "Hydrolyzed Pork Liver" },
  { name: "Hydrolyzed Poultry Protein" },
  { name: "Hydrolyzed Salmon" },
  { name: "Hydrolyzed Soy Protein" },
  { name: "Hydrolyzed Yeast" },
  { name: "Hydrolyzed Yeast Flavoring" },
  { name: "Ingredients Brewers Rice" },
  { name: "Ingredients Corn" },
  { name: "Inulin" },
  { name: "Iron Amino Acid Chelate" },
  { name: "Iron Carbonate" },
  { name: "Iron Glycine Complex" },
  { name: "Iron Oxide" },
  { name: "Iron Oxide Color" },
  { name: "Iron Proteinate" },
  { name: "Iron Sulfate" },
  { name: "Juniper" },
  { name: "Kale" },
  { name: "Kelp" },
  { name: "L-Arginine" },
  { name: "L-Carnitine" },
  { name: "L-Cysteine" },
  { name: "L-Lysine" },
  { name: "L-Lysine Monohydrochloride" },
  { name: "L-Threonine" },
  { name: "L-Tryptophan" },
  { name: "Lactic Acid" },
  { name: "Lamb" },
  { name: "Lamb Broth" },
  { name: "Lamb Heart" },
  { name: "Lamb Kidney" },
  { name: "Lamb Liver" },
  { name: "Lamb Lung" },
  { name: "Lamb Meal" },
  { name: "Lamb Tripe" },
  { name: "Lecithin" },
  { name: "Lemon Juice" },
  { name: "Lentil Fiber" },
  { name: "Lentils" },
  { name: "Leucine" },
  { name: "Liver Flavor" },
  { name: "Locust Bean Gum" },
  { name: "Long Grain Rice" },
  { name: "Mackerel" },
  { name: "Magnesium Oxide" },
  { name: "Magnesium Proteinate" },
  { name: "Magnesium Sulfate" },
  { name: "Malted Barley" },
  { name: "Malted Barley Extract" },
  { name: "Manganese Amino Acid Chelate" },
  { name: "Manganese Amino Acid Complex" },
  { name: "Manganese Methionine Hydroxy Analogue Chelate" },
  { name: "Manganese Oxide" },
  { name: "Manganese Proteinate" },
  { name: "Manganese Sulfate" },
  { name: "Manganous Oxide" },
  { name: "Manganous Sulfate" },
  { name: "Mannan Oligosaccharide" },
  { name: "Marigold Extract" },
  { name: "Marine Microalgae Oil" },
  { name: "Marshmallow Root" },
  { name: "Meat And Bone Meal" },
  { name: "Meat Broth" },
  { name: "Meat By-Product" },
  { name: "Medium Chain Triglyceride Vegetable Oil" },
  { name: "Menadione Sodium Bisulfate" },
  { name: "Menadione Sodium Bisulfate Complex" },
  { name: "Milk" },
  { name: "Milled Rice" },
  { name: "Minerals" },
  { name: "Minerals Potassium Chloride" },
  { name: "Minerals Zinc Amino Acid Chelate" },
  { name: "Minerals Zinc Oxide" },
  { name: "Miscanthus Grass" },
  { name: "Modified Corn Starch" },
  { name: "Modified Rice Starch" },
  { name: "Modified Tapioca Starch" },
  { name: "Monkfish" },
  { name: "Mono And Dicalcium Phosphate" },
  { name: "Monocalcium Phosphate" },
  { name: "Monosodium Phosphate" },
  { name: "Montmorillonite Clay" },
  { name: "Mussel" },
  { name: "Mussels" },
  { name: "Navy Beans" },
  { name: "New Zealand Green Mussel" },
  { name: "Oat Fiber" },
  { name: "Oat Groats" },
  { name: "Oat Meal" },
  { name: "Oatmeal" },
  { name: "Oats" },
  { name: "Oils And Fats" },
  { name: "Olive Oil" },
  { name: "Oregano" },
  { name: "Pantothenic Acid" },
  { name: "Papaya" },
  { name: "Papaya Powder" },
  { name: "Paprika" },
  { name: "Paprika Oleoresin" },
  { name: "Parsley" },
  { name: "Parsley Flakes" },
  { name: "Partially Hydrogenated Vegetable Oil" },
  { name: "Pea" },
  { name: "Pea Fiber" },
  { name: "Pea Flour" },
  { name: "Pea Protein" },
  { name: "Pea Starch" },
  { name: "Pears" },
  { name: "Peppermint Leaf Powder" },
  { name: "Phosphoric Acid" },
  { name: "Pinto Beans" },
  { name: "Pollock" },
  { name: "Pollock Meal" },
  { name: "Pollock Oil" },
  { name: "Pomegranate" },
  { name: "Pomegranate Powder" },
  { name: "Porcine Plasma" },
  { name: "Pork" },
  { name: "Pork Broth" },
  { name: "Pork By-Product" },
  { name: "Pork Fat" },
  { name: "Pork Flavor" },
  { name: "Pork Kidney" },
  { name: "Pork Liver" },
  { name: "Pork Lung" },
  { name: "Pork Meal" },
  { name: "Pork Plasma" },
  { name: "Potassium Alginate" },
  { name: "Potassium Carbonate" },
  { name: "Potassium Chloride" },
  { name: "Potassium Citrate" },
  { name: "Potassium Iodide" },
  { name: "Potassium Sorbate" },
  { name: "Potassium Sulfate" },
  { name: "Potato" },
  { name: "Potato Protein" },
  { name: "Potato Starch" },
  { name: "Poultry" },
  { name: "Poultry Broth" },
  { name: "Poultry By-Product" },
  { name: "Poultry By-Product Meal" },
  { name: "Poultry Fat" },
  { name: "Poultry Giblets" },
  { name: "Poultry Liver" },
  { name: "Powdered Cellulose" },
  { name: "Powdered Psyllium Seed Husk" },
  { name: "Prawn" },
  { name: "Preservative" },
  { name: "Probiotic" },
  { name: "Psyllium Husk" },
  { name: "Psyllium Seed Husk" },
  { name: "Psyllium Seed Husks" },
  { name: "Pumpkin" },
  { name: "Quail" },
  { name: "Quinoa Seed" },
  { name: "Rabbit" },
  { name: "Rabbit Kidney" },
  { name: "Rabbit Liver" },
  { name: "Rabbit Lung" },
  { name: "Rabbit Meal" },
  { name: "Rainbow Trout" },
  { name: "Red Lentils" },
  { name: "Reduced Iron" },
  { name: "Rice" },
  { name: "Rice Flour" },
  { name: "Rice Hulls" },
  { name: "Rice Starch" },
  { name: "Rosehip" },
  { name: "Rosemary" },
  { name: "Rosemary Extract" },
  { name: "Sage" },
  { name: "Salmon" },
  { name: "Salmon Broth" },
  { name: "Salmon Flavor" },
  { name: "Salmon Meal" },
  { name: "Salmon Oil" },
  { name: "Salt" },
  { name: "Sardine" },
  { name: "Sardine Broth" },
  { name: "Sardine Meal" },
  { name: "Sardines" },
  { name: "Sarsaparilla" },
  { name: "Seaweed Meal" },
  { name: "Shrimp" },
  { name: "Shrimp Meal" },
  { name: "Smoke Flavor" },
  { name: "Sodium Acid Pyrophosphate" },
  { name: "Sodium Aluminosilicate" },
  { name: "Sodium Bisulfate" },
  { name: "Sodium Carbonate" },
  { name: "Sodium Caseinate" },
  { name: "Sodium Chloride" },
  { name: "Sodium Hexametaphosphate" },
  { name: "Sodium Phosphate" },
  { name: "Sodium Pyrophosphate" },
  { name: "Sodium Selenite" },
  { name: "Sodium Silico Aluminate" },
  { name: "Sodium Tripolyphosphate" },
  { name: "Sole" },
  { name: "Soy Flour" },
  { name: "Soy Protein Concentrate" },
  { name: "Soy Protein Isolate" },
  { name: "Soybean Hulls" },
  { name: "Soybean Meal" },
  { name: "Soybean Oil" },
  { name: "Spearmint Extract" },
  { name: "Spelt" },
  { name: "Spinach" },
  { name: "Squash" },
  { name: "Sugar" },
  { name: "Suncured Alfalfa" },
  { name: "Suncured Alfalfa Meal" },
  { name: "Sunflower Lecithin" },
  { name: "Sunflower Oil" },
  { name: "Sunflower Seed Oil" },
  { name: "Sunflower Seeds" },
  { name: "Sweet Potato" },
  { name: "Tannic Acid" },
  { name: "Tapioca" },
  { name: "Tapioca Flour" },
  { name: "Tapioca Starch" },
  { name: "Taurine" },
  { name: "Tetrasodium Pyrophosphate" },
  { name: "Thiamine Hydrochloride" },
  { name: "Thyme" },
  { name: "Tilapia" },
  { name: "Tomato" },
  { name: "Tomato Pomace" },
  { name: "Tomatoes" },
  { name: "Tricalcium Phosphate" },
  { name: "Trout" },
  { name: "Tuna" },
  { name: "Tuna Broth" },
  { name: "Tuna Flavor" },
  { name: "Tuna Meal" },
  { name: "Tuna Oil" },
  { name: "Turkey" },
  { name: "Turkey Broth" },
  { name: "Turkey By-Product" },
  { name: "Turkey Giblets" },
  { name: "Turkey Gizzard" },
  { name: "Turkey Heart" },
  { name: "Turkey Liver" },
  { name: "Turkey Meal" },
  { name: "Turmeric" },
  { name: "Vegetable Broth" },
  { name: "Vegetable Flavor" },
  { name: "Vegetable Glycerin" },
  { name: "Vegetable Juice For Color" },
  { name: "Vegetable Oil" },
  { name: "Vegetable Starch Modified" },
  { name: "Venison" },
  { name: "Venison Kidney" },
  { name: "Venison Liver" },
  { name: "Venison Tripe" },
  { name: "Vinegar" },
  { name: "Vitamin A" },
  { name: "Vitamin B1" },
  { name: "Vitamin B12" },
  { name: "Vitamin B2" },
  { name: "Vitamin B3" },
  { name: "Vitamin B5" },
  { name: "Vitamin B6" },
  { name: "Vitamin B7" },
  { name: "Vitamin B9" },
  { name: "Vitamin C" },
  { name: "Vitamin D3" },
  { name: "Vitamin E" },
  { name: "Vitamin K" },
  { name: "Vitamin K3" },
  { name: "Vitamins" },
  { name: "Water" },
  { name: "Wheat" },
  { name: "Wheat Flour" },
  { name: "Wheat Gluten" },
  { name: "White Sweet Potato" },
  { name: "Whitefish" },
  { name: "Whitefish Meal" },
  { name: "Wild Boar" },
  { name: "Xanthan Gum" },
  { name: "Yeast Culture" },
  { name: "Yeast Extract" },
  { name: "Yellow Pea" },
  { name: "Yellow Squash" },
  { name: "Yucca Schidigera" },
  { name: "Yucca Schidigera Extract" },
  { name: "Zinc Amino Acid Chelate" },
  { name: "Zinc Amino Acid Complex" },
  { name: "Zinc Chelate Of Amino Acids Hydrate" },
  { name: "Zinc Methionine Hydroxy Analogue Chelate" },
  { name: "Zinc Oxide" },
  { name: "Zinc Proteinate" },
  { name: "Zinc Sulfate" },
  { name: "Zinc Sulphate Monohydrate" }
];
